import { combineReducers } from 'redux';

import channels from './channels';
import videos from './videos';

export default combineReducers({
  videos,
  channels,
});



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/entities/index.js